module.exports = __webpack_public_path__ + "static/esports-d4f2ec73ad88f1603a017f4a4b2aa2ec.svg";